<tt-page *ngIf="!!setting">
    <div class="col-xs-12 sp-0 height-full" *ngIf="'mobile' | mediaQuery">
        <tt-card>
            <ng-container *ngTemplateOutlet="info"></ng-container>
        </tt-card>

        <tt-grid *ngIf="!!grid" class="flex-1" [(ttOptions)]="grid"></tt-grid>
    </div>

    <div class="height-full" *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <tt-divider ttRememberId="pojoblabours_dividers">
            <tt-divider-columns>
                <tt-divider-pane ttSize="30">
                    <tt-card class="col-xs-12 p-5">
                        <ng-container *ngTemplateOutlet="info"></ng-container>
                    </tt-card>
                </tt-divider-pane>

                <tt-divider-pane ttSize="70">
                    <tt-grid *ngIf="!!grid" class="p-5 flex-1" [(ttOptions)]="grid"></tt-grid>
                </tt-divider-pane>
            </tt-divider-columns>
        </tt-divider>
    </div>
</tt-page>

<ng-template #info>
    <ng-container *ngIf="!!setting">
        <tt-input ttLabel="prod_id" [ttModel]="setting.prod_id" ttReadonly></tt-input>
        <tt-input ttLabel="prod_name" [ttModel]="setting.prod_name" ttReadonly></tt-input>
        <tt-input ttLabel="prod_id_and_name" [ttModel]="setting.prod_id_and_name" ttReadonly></tt-input>
        <tt-input ttLabel="postatus_name" [ttModel]="setting.postatus_name" ttReadonly></tt-input>
        <tt-input ttLabel="workgrp_name" [ttModel]="setting.workgrp_name" ttReadonly></tt-input>
        <tt-input ttLabel="equipment_name" [ttModel]="setting.equipment_name" ttReadonly></tt-input>
        <tt-input ttLabel="operation_name" [ttModel]="setting.operation_name" ttReadonly></tt-input>
        <tt-input ttLabel="start_dt" [ttModel]="setting.start_dt" ttReadonly></tt-input>
        <tt-input ttLabel="end_dt" [ttModel]="setting.end_dt" ttReadonly></tt-input>
    </ng-container>
</ng-template>
